module.exports = __webpack_public_path__ + "static/media/history_tang.5b3afe80.png";